module.exports = __webpack_public_path__ + "static/media/loading.fd967f3d.svg";